import { useEffect } from "react";
import { motion } from "framer-motion";
import { StaxMark } from "./Logo";

const BARS = ["#ffff00", "#ff0090", "#127ddd", "#252827"];

export const IntroLoader = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2350);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div data-testid="intro-loader" className="fixed inset-0 z-[100] pointer-events-none">
      <div className="absolute inset-0 flex">
        {BARS.map((c, i) => (
          <motion.div
            key={c}
            className="h-full flex-1"
            style={{ background: c }}
            initial={{ y: 0 }}
            animate={{ y: "-100%" }}
            transition={{ duration: 0.75, delay: 1.45 + i * 0.11, ease: [0.76, 0, 0.24, 1] }}
          />
        ))}
      </div>
      <motion.div
        className="absolute inset-0 flex flex-col items-center justify-center gap-5"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        transition={{ duration: 0.35, delay: 1.3 }}
      >
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="inline-block border-2 border-ink bg-white px-3.5 py-2.5">
            <StaxMark size={46} />
          </span>
        </motion.div>
        <div className="overflow-hidden">
          <motion.span
            className="block font-display uppercase text-6xl sm:text-8xl text-white mix-blend-difference leading-none"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.65, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          >
            STAX
          </motion.span>
        </div>
        <motion.span
          className="font-mono2 text-[11px] font-bold uppercase tracking-[0.5em] text-white mix-blend-difference"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.55, duration: 0.4 }}
        >
          Marketing LLC
        </motion.span>
      </motion.div>
    </div>
  );
};
